"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _pawnObjToIds = _interopRequireDefault(require("./pawnObjToIds.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = {
  pawnObjToIds: _pawnObjToIds["default"]
};